import React from 'react';

const Button = ({
  link = '',
  title,
  type = 'button',
  disabled = false,
  className = '',
  variant = 'primary',
  fullWidth = false,
}) => {
  const baseStyles = `
    px-8 py-3 text-lg font-semibold rounded-sm
    transition-all duration-300 cursor-pointer
    flex items-center justify-center gap-2
    relative overflow-hidden
    ${fullWidth ? 'w-full' : ''}
  `;

  const variantStyles = {
    primary: `bg-gradient-to-r from-accent-gold to-yellow-600 text-primary-dark
      hover:shadow-lg-gold hover:-translate-y-0.5
      disabled:opacity-50 disabled:cursor-not-allowed`,
    secondary: `bg-primary-dark text-text-light border-2 border-accent-gold/50
      hover:border-accent-gold hover:shadow-lg hover:-translate-y-0.5
      disabled:opacity-50 disabled:cursor-not-allowed`,
    tertiary: `bg-transparent text-accent-gold border-2 border-accent-gold
      hover:bg-accent-gold/10 hover:-translate-y-0.5
      disabled:opacity-50 disabled:cursor-not-allowed`,
  };

  const buttonClass = `${baseStyles} ${variantStyles[variant]} ${className}`;

  if (link) {
    return (
      <a href={link} className='no-underline'>
        <button disabled={disabled} className={buttonClass} type={type}>
          {title}
        </button>
      </a>
    );
  }

  return (
    <button disabled={disabled} className={buttonClass} type={type}>
      {title}
    </button>
  );
};

export default Button;
